up.on('up:form:submit', '.slide-form', ({ renderOptions }) => {
  renderOptions.onLoaded = function({ response }) {
    if (response.header('X-Course-Completed')) {
      renderOptions.transition = 'none'
    }
  }
})
